import { useAssignSettingLoggedInProductCategoryHubsRSCM2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedInProductCategoryHubsRSCM2";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { useIsSDUISeasonalHubPage } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useIsSDUISeasonalHubPage";
import { useEffect } from "react";

export const useAssignRSCM2CategoryPage = () => {
  const isProductFirstCategory = useShowProductFirstResults();
  const isSDUISeasonalHubPage = useIsSDUISeasonalHubPage();

  const assignSettingLoggedInProductCategoryHubsRSCM2 =
    useAssignSettingLoggedInProductCategoryHubsRSCM2();

  useEffect(() => {
    if (isProductFirstCategory || isSDUISeasonalHubPage) {
      assignSettingLoggedInProductCategoryHubsRSCM2();
    }
  }, [
    assignSettingLoggedInProductCategoryHubsRSCM2,
    isProductFirstCategory,
    isSDUISeasonalHubPage,
  ]);
};
